export enum DeviceIpAssignment {
  DYNAMIC = "dynamic",
  EXTERNAL = "external",
  STATIC = "static",
}

export enum DeviceMeta {
  MODEL = "device",
  PK = "system_id",
}
